var render = function render(){var _vm=this,_c=_vm._self._c;return _c('carousel',{attrs:{"classes":_vm.classes,"items":_vm.items,"options":_vm.options,"show-navigation":_vm.showNavigation},scopedSlots:_vm._u([{key:"slide",fn:function({ item }){return [_c('img',{staticClass:"full-width",attrs:{"src":item.url,"title":item.name,"alt":item.name}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }